import React from 'react'
import { css } from '@emotion/react'

interface ReminderItemProps {
  name: string
  value: number
  onChange: (value: number) => void
}

const ReminderItem = ({ name, value, onChange }: ReminderItemProps) => {
  return (
    <div css={baseStyle} className="reminder__body">
      <p>{name}</p>
      <input
        placeholder="X"
        type="number"
        value={value === 0 ? '' : value}
        onChange={(e) => {
          const val = parseInt(e.target.value)
          onChange(isNaN(val) ? 0 : val)
        }}
      />
      <p>days</p>
    </div>
  )
}

const baseStyle = css({
  display: 'flex',
  alignItems: 'center',
  gap: '5px',
  input: {
    textAlign: 'center',
    width: '40px',
    height: '30px',
    color: '#000000',
    border: '1px solid #C6C6C6',
    outline: 'none',
    '&:focus': {
      border: '1px solid #C6C6C6',
    },
    '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  p: {
    color: '#575757',
    fontSize: '12px',
    margin: 0,
    '&:first-of-type': {
      flex: 1,
      textAlign: 'end',
    },
    '&:last-of-type': {
      minWidth: '35px',
    },
  },
})

export default ReminderItem
